import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { openSimpleModal, closeSimpleModal } from "../../../actions/simpleModalActions";

ChangeToCash.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

export function ChangeToCash({ value, onChange }) {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);

  const onCheckHandler = (isChecked) => {
    setActive(isChecked);

    dispatch(
      openSimpleModal({
        body: (
          <p className="change-to-cash-text">
            {`This will ${isChecked ? "change" : "cancel"} the service to cash , are you sure?`}
          </p>
        ),
        footer: (
          <div className="flex align-items-center justify-content-end">
            <button
              className="btn btn-default"
              onClick={() => {
                setActive(false);
                dispatch(closeSimpleModal());
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                onChange(isChecked);
                dispatch(closeSimpleModal());
              }}
            >
              Ok
            </button>
          </div>
        ),
      }),
    );
  };

  return (
    <div role="button" className="change-to-cash-wrapper" onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        value={value}
        checked={active}
        onChange={({ target }) => onCheckHandler(target.checked)}
      />
    </div>
  );
}
